import React, { useLayoutEffect, useRef, useState } from "react";

// One line that shrinks to fit its box instead of being cut off (long masjid names, Jumu'ah times).
const FitText: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [scale, setScale] = useState(1);
  const [fontsReady, setFontsReady] = useState(false);

  useLayoutEffect(() => {
    document.fonts?.ready.then(() => setFontsReady(true));
  }, []);

  useLayoutEffect(() => {
    const el = ref.current;
    const box = el?.parentElement;
    if (!el || !box || !el.offsetWidth) return;
    const natural = el.offsetWidth / scale;
    const next = Math.min(1, box.clientWidth / natural);
    if (Math.abs(next - scale) > 0.01) setScale(next);
  });

  return (
    <span ref={ref} style={{ fontSize: `${scale}em`, whiteSpace: "nowrap" }}>
      {children}
    </span>
  );
};

export default FitText;
